const optionsOnlyStyles = `
  .is-product-page .pdp-media-tabs,
  .is-product-page .preview-heading,
  .is-product-page #model-evidence-note,
  .is-product-page #stage,
  .is-product-page .preview-toolbar,
  .is-product-page .pdp-gallery-tools,
  .is-product-page .pdp-screen-dropdown,
  .is-product-page .preview-control,
  .is-product-page .preview-pill,
  .is-product-page .electric-light,
  .is-product-page .tora-colours {
    display: none !important;
  }

  .aura-body.is-product-page .pdp-preview-column {
    position: static !important;
    top: auto !important;
    align-self: auto !important;
    z-index: auto !important;
  }

  .aura-body.is-product-page .pdp-preview-column > .preview {
    display: block !important;
    position: static !important;
    top: auto !important;
    z-index: auto !important;
    transform: none !important;
  }

  .is-product-page > .builder > .control-panel {
    display: block !important;
    position: static !important;
    width: 100% !important;
    max-width: 1040px !important;
    margin: 0 auto !important;
    padding: 0 !important;
  }

  .is-product-page > .builder > .control-panel > :not(.pdp-build-drawer):not(.shop-intro):not(.luxsol-info) {
    display: none !important;
  }

  .is-product-page .shop-intro {
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding-bottom: 0 !important;
  }

  .aura-body.is-product-page .shop-intro .pdp-product-intro {
    padding: 0 !important;
  }

  @media (max-width: 800px) {
    .aura-body.is-product-page .shop-intro .pdp-product-intro {
      padding-top: 28px !important;
    }
  }

  .aura-body.is-product-page .shop-intro .pdp-product-intro h1 {
    margin-bottom: 12px !important;
    font-size: clamp(28px, 2.5vw, 35px) !important;
    max-width: 540px !important;
  }

  .aura-body.is-product-page .shop-intro .pdp-description {
    margin-bottom: 16px !important;
  }

  .aura-body.is-product-page .shop-intro .pdp-price-panel {
    margin-bottom: 12px !important;
    padding: 14px 16px !important;
  }

  .aura-body.is-product-page .shop-intro .pdp-key-features {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 0 !important;
    border-top: 1px solid var(--line) !important;
    margin-bottom: 0 !important;
  }

  .aura-body.is-product-page .shop-intro .pdp-key-features li {
    display: flex !important;
    min-height: 0 !important;
    padding: 12px 0 !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 12px !important;
    border: 0 !important;
    border-bottom: 1px solid var(--line) !important;
    border-radius: 0 !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    line-height: 1.35 !important;
    white-space: nowrap !important;
  }

  .aura-body.is-product-page .shop-intro .pdp-key-features li svg {
    box-sizing: content-box !important;
    width: 22px !important;
    height: 22px !important;
    padding: 6px !important;
    border-radius: 50% !important;
    background: #e8f0ed !important;
    color: var(--green) !important;
    flex: 0 0 22px !important;
  }

  .aura-body.is-product-page .pdp-build-drawer {
    margin-top: 12px !important;
  }

  /* Keep the order summary in the page flow when the builder leaves view.
     Hiding it collapses the mobile PDP and shifts the scroll position. */
  @media (max-width: 980px) {
    .aura-body.is-product-page.pdp-out-of-view .basket-strip {
      display: grid !important;
    }
  }

  .aura-body.is-product-page .pdp-your-build,
  .aura-body.is-product-page .pdp-your-build h3,
  .aura-body.is-product-page .pdp-your-build-summary,
  .aura-body.is-product-page .pdp-your-build .pdp-build-line > span:first-child,
  .aura-body.is-product-page .pdp-your-build .pdp-build-line-title,
  .aura-body.is-product-page .pdp-your-build .pdp-build-line small {
    text-align: left !important;
  }

  .aura-body.is-product-page .pdp-your-build .pdp-build-line-price {
    text-align: right !important;
  }

  .aura-body.is-product-page #panel-roof[data-included-roof] .side-title,
  .aura-body.is-product-page #panel-roof[data-included-roof] > .helper,
  .aura-body.is-product-page #panel-roof[data-included-roof] .roof-cards {
    display: none !important;
  }

  .is-product-page .pdp-manual-roof {
    display: grid;
    grid-template-columns: 58px minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    min-height: 88px;
    padding: 14px;
    border: 2px solid var(--green);
    border-radius: 10px;
    background: var(--soft);
  }

  .is-product-page .pdp-manual-roof svg {
    display: block;
    width: 58px;
    height: 50px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
  }

  .is-product-page .pdp-manual-roof strong,
  .is-product-page .pdp-manual-roof small {
    display: block;
  }

  .is-product-page .pdp-manual-roof strong {
    font-size: 15px;
    line-height: 1.3;
  }

  .is-product-page .pdp-manual-roof small {
    margin-top: 4px;
    color: var(--muted);
    font-size: 11px;
    line-height: 1.45;
  }

  .is-product-page .pdp-manual-roof-badge {
    padding: 5px 8px;
    border-radius: 999px;
    background: var(--green);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  .is-product-page .pdp-preview-column,
  .is-product-page .pdp-preview-column > .preview,
  .is-product-page .pdp-photos,
  .is-product-page .pdp-photo-stage,
  .is-product-page .pdp-photo-track {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .is-product-page .pdp-photo-stage img {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    object-fit: contain !important;
  }

  .is-product-page .pdp-photo-navigation {
    display: none !important;
  }

  .is-product-page .pdp-thumbnails [aria-pressed="true"] {
    border-color: transparent !important;
    box-shadow: none !important;
  }

  @media (min-width: 981px) {
    .aura-body.is-product-page .pdp-build-drawer {
      margin-top: 24px !important;
    }

    .is-product-page .builder {
      display: grid !important;
      grid-template-columns: minmax(0, 62fr) minmax(420px, 38fr) !important;
      gap: clamp(32px, 3vw, 40px) !important;
      justify-content: center !important;
      align-items: start !important;
      width: calc(100% - 96px) !important;
      max-width: 1500px !important;
      margin-inline: auto !important;
      padding-inline: 0 !important;
      box-sizing: border-box !important;
    }

    .aura-body.is-product-page .pdp-preview-column {
      position: sticky !important;
      top: var(--luxsol-product-sticky-top, 16px) !important;
      align-self: start !important;
      z-index: 2 !important;
    }

    .is-product-page .pdp-preview-column,
    .is-product-page > .builder > .control-panel {
      max-width: none !important;
    }

    .is-product-page .pdp-photos,
    .is-product-page .pdp-photos[hidden] {
      position: relative !important;
      box-sizing: border-box !important;
      padding-left: 132px !important;
      margin-bottom: 0 !important;
    }

    .is-product-page .pdp-thumbnails {
      position: absolute !important;
      inset: 0 auto 0 0 !important;
      display: flex !important;
      flex-direction: column !important;
      width: 120px !important;
      gap: 10px !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      padding: 0 4px 0 0 !important;
      scrollbar-width: thin !important;
    }

    .is-product-page .pdp-thumbnails button {
      width: 116px !important;
      min-width: 116px !important;
      height: 87px !important;
      min-height: 87px !important;
    }
  }

  .is-product-page .pdp-photos,
  .is-product-page .pdp-photos[hidden] {
    display: block !important;
    margin-bottom: 28px !important;
  }

  @media (max-width: 800px) {
    .is-product-page > .builder > .control-panel {
      display: none !important;
    }

    .is-product-page .pdp-photos,
    .is-product-page .pdp-photos[hidden] {
      margin-bottom: 16px !important;
    }

    .is-product-page .pdp-thumbnails {
      display: flex !important;
      gap: 8px !important;
      padding: 8px 0 0 !important;
    }

    .is-product-page .pdp-thumbnails button {
      width: 112px !important;
      min-width: 112px !important;
      height: 84px !important;
    }
  }

  /* The product story belongs with Photos. Keep the compact builder focused on
     the preview and choices, while restoring the full introduction on return. */
  @media (max-width: 980px) {
    .aura-body.is-product-page.lx-renderer-pdp:not(.lx-photos) .shop-intro {
      display: none !important;
    }
  }
`;

function enableOptionsOnlyProductPage(builder) {
  const installStyles = () => {
    if (!builder.shadowRoot) {
      requestAnimationFrame(installStyles);
      return;
    }

    if (builder.shadowRoot.querySelector('[data-options-only-product-page]')) return;

    const style = document.createElement('style');
    style.dataset.optionsOnlyProductPage = '';
    style.textContent = optionsOnlyStyles;
    builder.shadowRoot.append(style);

    const config = JSON.parse(builder.querySelector('[data-aura-config]')?.textContent || '{}');
    const body = builder.shadowRoot.querySelector('.aura-body');
    const roofPanel = builder.shadowRoot.querySelector('#panel-roof');

    // The core builder updates this node after every option change. Keep it in
    // the DOM and hide it with CSS so mobile selections can finish syncing.

    // Keep the three model size cards visually consistent without changing stock logic.
    const sizeCards = builder.shadowRoot.querySelector('.size-cards');
    if (sizeCards) {
      const tidySizeCards = () => {
        sizeCards.querySelectorAll('.size-card').forEach((card) => {
          // Tora's built-in outline adds a tiny size caption inside the SVG;
          // the adjacent card title already provides that information.
          card.querySelector('svg text')?.remove();

          if (card.dataset.size === '8x4') {
            const icon = card.querySelector('svg');
            if (icon && icon.dataset.toraSixPost !== 'true') {
              icon.innerHTML = '<path d="M5 21 23 10 95 21 77 32Z" fill="currentColor" fill-opacity=".08"/><path d="M5 21v5l72 12 18-11v-6M77 32v6"/><path d="M5 26v33h3V27M41 32v32h3V33M77 38v31h3V39M95 27v31h-3V28M23 16v31h3V17M59 22v31h3V23"/><path d="m12 18 72 12M19 14l72 12M26 11l69 11"/>';
              icon.dataset.toraSixPost = 'true';
            }
          }

          const price = card.querySelector('.option-price');
          if (!price) return;
          const cleanPrice = price.textContent.replace(/\s*·\s*Unavailable\s*$/i, '');
          if (price.textContent !== cleanPrice) price.textContent = cleanPrice;
        });
      };

      tidySizeCards();
      new MutationObserver(tidySizeCards).observe(sizeCards, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    const family = config.family || 'aura';
    const roofTitle = family === 'aura' ? config.labels?.manualRoof : builder.dataset.electricRoofTitle;
    const roofCopy = family === 'aura' ? config.labels?.manualRoofCopy : builder.dataset.electricRoofCopy;
    const includedLabel = family === 'aura' ? config.labels?.included : builder.dataset.includedLabel;

    if (body && roofPanel && roofTitle && roofCopy) {
      roofPanel.dataset.includedRoof = '';

      const roofCards = roofPanel.querySelector('.roof-cards');

      if (roofCards && !roofPanel.querySelector('.pdp-manual-roof')) {
        const includedRoof = document.createElement('div');
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        const detail = document.createElement('small');
        const badge = document.createElement('span');
        const icon = roofCards.querySelector('[data-roof="open"] svg')?.cloneNode(true);

        includedRoof.className = 'pdp-manual-roof';
        includedRoof.setAttribute('role', 'note');
        title.textContent = roofTitle;
        detail.textContent = roofCopy;
        badge.className = 'pdp-manual-roof-badge';
        badge.textContent = includedLabel || 'Included';

        if (icon) includedRoof.append(icon);
        copy.append(title, detail);
        includedRoof.append(copy, badge);
        roofCards.before(includedRoof);
      }
    }

    const compactLayout = matchMedia('(max-width: 980px)');
    const positionProductIntro = () => {
      const root = builder.shadowRoot;
      const intro = root.querySelector('.shop-intro');
      const previewColumn = root.querySelector('.pdp-preview-column');
      const preview = previewColumn?.querySelector(':scope > .preview');
      const controlPanel = root.querySelector('.control-panel');
      const drawer = root.querySelector('.pdp-build-drawer');
      const information = root.querySelector('.luxsol-info');

      if (!intro || !previewColumn || !controlPanel) return;

      if (compactLayout.matches) {
        if (intro.parentElement !== previewColumn || intro.previousElementSibling !== preview) {
          if (preview) {
            preview.after(intro);
          } else {
            previewColumn.prepend(intro);
          }
        }
        if (drawer && information && drawer.nextElementSibling !== information) drawer.after(information);
        return;
      }

      if (intro.parentElement !== controlPanel || intro.nextElementSibling !== drawer) {
        controlPanel.insertBefore(intro, drawer || controlPanel.firstElementChild);
      }
      if (drawer && information && drawer.nextElementSibling !== information) drawer.after(information);
    };

    compactLayout.addEventListener('change', positionProductIntro);
    positionProductIntro();

    const inlineVideo = builder.shadowRoot.querySelector('[data-inline-player]');
    const video = inlineVideo?.querySelector('video');
    const videoCover = inlineVideo?.querySelector('[data-video-cover]');

    if (video && videoCover) {
      const runtime = inlineVideo.querySelector('[data-video-runtime]');
      const status = inlineVideo.querySelector('[data-video-status]');

      const updateRuntime = () => {
        if (!runtime || !Number.isFinite(video.duration)) return;
        const seconds = Math.round(video.duration);
        runtime.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
        runtime.hidden = false;
      };

      const showPlaybackError = () => {
        videoCover.hidden = false;
        if (status) {
          status.textContent = inlineVideo.dataset.playError || '';
          status.hidden = false;
        }
      };

      video.addEventListener('loadedmetadata', updateRuntime);
      if (video.readyState >= 1) updateRuntime();

      videoCover.addEventListener('click', async () => {
        if (video.ended || video.currentTime >= video.duration - 0.25) video.currentTime = 0;
        videoCover.hidden = true;
        if (status) status.hidden = true;
        try {
          await video.play();
          videoCover.setAttribute('aria-label', inlineVideo.dataset.playLabel || '');
        } catch {
          showPlaybackError();
        }
      });

      video.addEventListener('ended', () => {
        video.currentTime = 0;
        videoCover.hidden = false;
        videoCover.setAttribute('aria-label', inlineVideo.dataset.replayLabel || '');
        const action = videoCover.querySelector('[data-video-action]');
        if (action) action.textContent = inlineVideo.dataset.replayCopy || '';
      });
      video.addEventListener('error', showPlaybackError);
      inlineVideo.dataset.videoEnhanced = '';

      if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches && inlineVideo.getBoundingClientRect().top > window.innerHeight * 0.8) {
        inlineVideo.classList.add('is-awaiting-view');
        const reveal = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          inlineVideo.classList.remove('is-awaiting-view');
          reveal.disconnect();
        }, { threshold: 0.12 });
        reveal.observe(inlineVideo);
      }
    }

    let stickyOffsetFrame = 0;
    let trackHeaderUntil = 0;

    const updateDesktopStickyOffset = () => {
      if (compactLayout.matches) {
        builder.style.removeProperty('--luxsol-product-sticky-top');
        return;
      }

      const header = document.querySelector('store-header');
      const visibleHeaderBottom = header
        ? Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom))
        : 0;

      builder.style.setProperty(
        '--luxsol-product-sticky-top',
        `${Math.ceil(visibleHeaderBottom + 16)}px`
      );
    };

    const trackDesktopHeader = () => {
      trackHeaderUntil = performance.now() + 520;
      if (stickyOffsetFrame) return;

      const tick = () => {
        updateDesktopStickyOffset();

        if (performance.now() < trackHeaderUntil) {
          stickyOffsetFrame = requestAnimationFrame(tick);
        } else {
          stickyOffsetFrame = 0;
        }
      };

      stickyOffsetFrame = requestAnimationFrame(tick);
    };

    window.addEventListener('scroll', trackDesktopHeader, { passive: true });
    window.addEventListener('resize', trackDesktopHeader, { passive: true });
    compactLayout.addEventListener('change', trackDesktopHeader);
    trackDesktopHeader();
  };

  installStyles();
}

customElements.whenDefined('aura-builder').then(() => {
  document.querySelectorAll('aura-builder').forEach(enableOptionsOnlyProductPage);

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('aura-builder')) enableOptionsOnlyProductPage(node);
        node.querySelectorAll('aura-builder').forEach(enableOptionsOnlyProductPage);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
});
